import styled from 'styled-components';
import { Icon } from 'antd';
import { FaExclamationCircle, FaInfoCircle } from 'react-icons/fa';

export const PreflightCheckContainer = styled.div`
  display: flex;
  align-items: center;
  > div {
   display: flex;
  }
  aside {
    margin-left: 1em;
  }
  :not(:last-child) {
    margin-bottom: 2em;
  }
`;

export const ErrorIcon = styled(FaExclamationCircle)`
  color: #FF2558;
  font-size: 1.5em;
`;

export const WarningIcon = styled(FaExclamationCircle)`
  color: #ff9c22;
  font-size: 1.5em;
`;

export const InfoIcon = styled(FaInfoCircle)`
  color: #0099FF;
  font-size: 1.5em;
`;

export const PreflightLoader = styled(Icon)`
  justify-content: center;
  font-size: 2em;
  &.anticon {
    display: flex;
  }
`;
